// @ts-nocheck



import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { navigate } from '../../../lib/routerAdapter';
import notification from 'antd/lib/notification';
import Button from 'antd/lib/button';
import Modal from '../../../components/ant/Modal';
import Input from 'antd/lib/input';
import Form from 'antd/lib/form';

import { Card } from './../../../components';






import {
  clear,
  fetchRepairOrder,
  updateRepairOrder } from
'../../../ducks/repairOrder';

import { Panel, Section, SectionTitle } from './../../../components/layout';
import Grid, { GridItem } from './../../../components/layout/Grid';
import { withUserAccess } from './../../withUserAccess';
import Header from '../../../components/layout/Header';
import Breadcrumbs, { Crumb } from '../../../components/layout/Breadcrumbs';
import { Icon } from '../../../components/ui';
import { notificationLoading } from '../../../components/Notifications';
import { InputNumber } from '../../../components/inputs';

const { Field } = Card;

const StyledIcon = styled(Icon).withConfig({ displayName: "RepairOrderCard__StyledIcon", componentId: "sc-qrzr89-0" })(["padding:0 10px;color:#1890ff;cursor:pointer;"]);





const StyledPanel = styled(Panel).withConfig({ displayName: "RepairOrderCard__StyledPanel", componentId: "sc-qrzr89-1" })(["display:flex;justify-content:space-between;align-items:center;padding-top:0;"]);






const Content = styled.div.withConfig({ displayName: "RepairOrderCard__Content", componentId: "sc-qrzr89-2" })(["padding:16px;"]);



const Footer = styled(Section).withConfig({ displayName: "RepairOrderCard__Footer", componentId: "sc-qrzr89-3" })(["padding:16px;display:flex;justify-content:space-between;align-items:center;"]);





const FormItem = Form.Item;
















export class RepairOrderCard extends Component {
  state = {
    showActForm: false,
    amountPayment: 0,
    actNumber: ''
  };

  async componentDidMount() {
    const { repairOrderId } = this.props;
    if (repairOrderId) {
      try {
        await this.props.fetchRepairOrder(repairOrderId);
      } catch (err) {
        notification.error({
          message: 'Ошибка',
          description: err.message
        });
      }
    }
  }

  componentWillUnmount() {
    this.props.clear();
  }

  updateRepairOrder = async (fieldName, value) => {
    try {
      notificationLoading({
        message: 'Сохранение данных...',
        key: 'saving'
      });
      await this.props.updateRepairOrder({
        ...this.props.repairOrder,
        [fieldName]: value
      });
    } catch (err) {
      notification.error({
        message: 'Ошибка при обновлении',
        description: err.message
      });
    } finally {
      notification.destroy('saving');
    }
  };

  toggleActForm = () =>
  this.setState((prevState) => ({ showActForm: !prevState.showActForm }));

  onUpdate = () => {
    const { actNumber, amountPayment } = this.state;
    this.props.updateRepairOrder({
      ...this.props.repairOrder,
      actNumber,
      amountPayment
    });
  };

  render() {
    const { repairOrder } = this.props;
    const { showActForm, amountPayment } = this.state;
    if (!repairOrder) {
      return null;
    }

    return (
      <Fragment>
        <Header
          left={
          <Breadcrumbs>
              <Crumb to="/">Транспорт</Crumb>
              <Crumb to="/services">Обслуживание</Crumb>
              <Crumb>Заявка на ремонт №{repairOrder.id}</Crumb>
            </Breadcrumbs>
          } />

        <StyledPanel>
          <h1>
            Заявка на ремонт №{repairOrder.id}
            <StyledIcon
              onClick={() =>
              navigate(`/services/repair-order/edit/${repairOrder.id}`)
              }
              type="edit"
              size={16} />

          </h1>
        </StyledPanel>
        <Section>
          <Content>
            <Grid cols={2} gutter="16">
              {repairOrder.contractor &&
              <GridItem>
                  <Field label="Подрядчик">
                    {repairOrder.contractor.company ?
                  repairOrder.contractor.company.name :
                  repairOrder.contractor.name}
                  </Field>
                </GridItem>
              }
              <GridItem>
                <Field label="№ договора">{repairOrder.contractNumber}</Field>
              </GridItem>
            </Grid>
          </Content>
        </Section>
        {repairOrder.vehicles.map((repairOrderVehicle) =>
        <Section key={repairOrderVehicle.vehicleId}>
            <SectionTitle divider>
              {repairOrderVehicle.vehicle ?
            <Fragment>
                  <span>
                    {repairOrderVehicle.vehicle.vehicleModel &&
                `${repairOrderVehicle.vehicle.vehicleModel.brandName} ${repairOrderVehicle.vehicle.vehicleModel.name} `}
                  </span>
                  <span>{repairOrderVehicle.vehicle.licensePlate}</span>
                </Fragment> :

            ''
            }
            </SectionTitle>
            <Content>
              <Grid>
                <GridItem>
                  <Field label="Виды работ">
                    {repairOrderVehicle.operations.map(
                    (repairOrderOperation) =>
                    <p key={repairOrderOperation.operationId}>
                          {repairOrderOperation.operation.name} (
                          {repairOrderOperation.count} шт.)
                        </p>

                  )}
                  </Field>
                </GridItem>
              </Grid>
            </Content>
          </Section>
        )}

        <Footer>
          <Button type="primary" onClick={this.toggleActForm}>
            Акт
          </Button>
        </Footer>
        <Modal
          title="Акт работ"
          visible={showActForm}
          onOk={this.onUpdate}
          onCancel={this.toggleActForm}>

          <Grid>
            <GridItem>
              <FormItem label="Номер акта">
                <Input
                  onChange={(e) =>
                  this.setState({
                    actNumber: e.target.value
                  })
                  } />

              </FormItem>
            </GridItem>
            <GridItem>
              <FormItem label="Сумма, руб">
                <InputNumber
                  value={amountPayment}
                  step={0.01}
                  onChange={(amountPayment) =>
                  this.setState({
                    amountPayment
                  })
                  } />

              </FormItem>
            </GridItem>
          </Grid>
        </Modal>
      </Fragment>);

  }
}

export default connect(
  (state) => ({
    repairOrder: state.repairOrder
  }),
  {
    fetchRepairOrder,
    updateRepairOrder,
    clear
  }
)(withUserAccess(RepairOrderCard));
